import HistoricalFundsBalanceError from './HistoricalFundsBalanceError';
class BalanceInvalidPropertyId extends HistoricalFundsBalanceError {
    propertyId;
    constructor(propertyId, options) {
        super('The id provided doesn\'t have a valid format', options);
        this.propertyId = propertyId;
    }
}
export default BalanceInvalidPropertyId;
